import { useLanguageContext } from "../../../context/LanguageContext";
import BusinessCenterCompaniesPage from "../../../pages/business_center_companies/index/BusinessCenterCompaniesPage";
import { useBusinessCenterCompaniesRouteValidator } from "../../validators/business_center_companies/BusinessCenterCompaniesRouteValidator";
import { RouteConfig } from "../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useBusinessCenterCompaniesRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/business_center_companies")
    .setLabel(translate("eva.main.entities.business_center_companies"))
    .setValidator(useBusinessCenterCompaniesRouteValidator())
    .setPage(<BusinessCenterCompaniesPage />);
}

export default useBusinessCenterCompaniesRouteConfig;
